var exports = {
  "A": "x1cb7f6e3--b58456--item",
};

module.exports = exports;
